import { attributes, AttributesMixin, define, Model } from "@type-r/models";
import { AssetTypeItem } from "./assetTypes";

export interface Criterian extends AttributesMixin<typeof Criterian> { }

@define
export class Criterian extends Model {
  static attributes = {
    assetType: AssetTypeItem,
    searchValue: String
  }
}

export interface FilterColumn extends AttributesMixin<typeof FilterColumn> { }

@define
export class FilterColumn extends Model {
  static attributes = {
    name: String,
    x: Number,
    y: Number
  }
}

export interface AssetFilterCriteria extends AttributesMixin<typeof AssetFilterCriteria> { }
@define
export class AssetFilterCriteria extends Model {
  static attributes = {
    filterColumn: FilterColumn,
    criteria: [Criterian]
  };
}

export type WorkSheet = InstanceType<typeof WorkSheet>;
export const WorkSheet = attributes({
    id: Number,
    name: String,
});